/* eslint-disable camelcase */
import {
  PhoneInput, FormFlow, Form,
} from '@common/vanilla_ui/general';
import gtmTracking from '@common/vanilla_ui/tracking/gtm';
import { toHHmm, getDayFullName, toDDMMM } from '@common/utils/date';
import Toastify from 'toastify-js';
import {
  getAttribution,
  setAttribution,
} from '@common/vanilla_ui/tracking/attribution';

const REGISTER_ENDPOINT = '/api/v3/events/book-free-webinar';

const formId = 'webinar-form';
const formContainerId = 'webinar-form-container';
const thankYouContainerId = 'webinar-thankyou-container';

const initializeOtpFormInputs = () => {
  new PhoneInput('webinar-form__phone');
};

const setFormAttribution = () => {
  const attributionProgram = 'software_development';
  setAttribution('webinar_register', {
    program: attributionProgram,
  });

  return getAttribution();
};


const setupMainForm = () => {
  const formContainer = document.getElementsByClassName(formContainerId)[0];
  const thankYouContainer = document.getElementsByClassName(
    thankYouContainerId,
  )[0];
  const form = new FormFlow(
    'webinar-form', 'webinar-form', 'page', 'register',
  );

  const formattedTimeElement = (start_time, end_time) => {
    const dateFormat = new Date(start_time);
    const timeRange = `${toHHmm(start_time)} - ${toHHmm(end_time)}`;
    const day = getDayFullName(start_time);
    const month = toDDMMM(start_time).split(' ')[1];
    const date = String(dateFormat.getDate()).padStart(2, '0');
    const year = dateFormat.getFullYear();

    const formattedTime = `${timeRange} ${day}, ${month} ${date} ${year}`;
    return formattedTime;
  };

  form.setFormHandler('register', () => {
    const otpForm = new Form(
      document.getElementById('webinar-form-otp'),
      {
        method: 'POST',
        endpoint: REGISTER_ENDPOINT,
        createPayload: values => ({
          ...values,
          attributions: setFormAttribution(),
        }),
        validations: {
          phone_number: 'mobile',
          graduation_year: 'required',
          email: 'email',
        },
      },
    );

    otpForm.addEventListener('invalidfields', (errors) => {
      const errorMessage = errors[Object.keys(errors)[0]];
      Toastify({
        text: errorMessage,
        className: 'toastify-danger',
      }).showToast();
    });

    otpForm.on('initialize', () => {
      initializeOtpFormInputs();
    });
    otpForm.on('submitted', (
      { data: { attributes: { title, start_time, end_time } } },
    ) => {
      gtmTracking.sendFormSubmitStatus(formId, true);
      formContainer.classList.add('hidden');
      const titleEl = document.getElementById('webinar-title');
      const timingEl = document.getElementById('webinar-timing');
      titleEl.textContent = title;
      timingEl.textContent = formattedTimeElement(start_time, end_time);
      thankYouContainer.classList.remove('hidden');
    });
    otpForm.on('error', error => {
      let message = 'Something went wrong! Please try again later';
      if (error && error.isFromServer) {
        switch (error.response.status) {
          case 429:
            message = 'Request rate exceeded, please try after sometime';
            break;
          case 422:
            message = 'Please fill the required fields';
            break;
          case 403:
            message = 'Email already registered';
            break;
          case 406:
            message = `Recaptcha validity has expired,
              please try refreshing the page`;
            break;
          case 409:
            message = 'Phone number is linked to a different email';
            break;
          case 400:
            message = error.responseJson.message;
            break;
          default:
          // Do nothing
        }
        gtmTracking.sendFormSubmitStatus(
          formId, false, message,
        );
      }
      Toastify({
        text: message,
        className: 'toastify-danger',
      }).showToast();
      otpForm.setError(message);
    });
    otpForm.initialize();
  });
  form.initialize();
};

const initialize = () => {
  const formEl = document.getElementById(formId);
  if (formEl) {
    setupMainForm();
  }
};

export default { initialize };
